var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNfsE(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.739,
    height: 17.571,
    viewBox: "0 0 21.739 17.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nfs-e",
    transform: "translate(-24.01 -27.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3063",
    "data-name": "Grupo 3063",
    transform: "translate(24.01 27.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2331",
    "data-name": "Caminho 2331",
    d: "M34.882,45.281H26.315a2.308,2.308,0,0,1-2.305-2.305V30.015a2.308,2.308,0,0,1,2.305-2.305h8.567a2.308,2.308,0,0,1,2.305,2.305v1.721a.365.365,0,0,1-.729,0V30.015a1.578,1.578,0,0,0-1.576-1.576H26.315a1.577,1.577,0,0,0-1.576,1.576V42.976a1.578,1.578,0,0,0,1.576,1.576h8.567a1.578,1.578,0,0,0,1.576-1.576V41.4a.365.365,0,0,1,.729,0v1.574A2.308,2.308,0,0,1,34.882,45.281Z",
    transform: "translate(-24.01 -27.71)",
    fill: "#64c2c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3064",
    "data-name": "Grupo 3064",
    transform: "translate(27.087 33.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2332",
    "data-name": "Caminho 2332",
    d: "M187.66,346.758h-1.333l-2.152-3.743h-.03q.064.992.064,1.415v2.329h-.938V341.81h1.323l2.149,3.706h.024q-.051-.965-.051-1.364V341.81h.944Z",
    transform: "translate(-183.27 -341.739)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2333",
    "data-name": "Caminho 2333",
    d: "M475.912,346.758H474.88V341.81h2.836v.86h-1.8v1.276h1.679v.856h-1.679Z",
    transform: "translate(-469.245 -341.739)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2334",
    "data-name": "Caminho 2334",
    d: "M659.205,341.785a1.279,1.279,0,0,1-.482,1.056,2.094,2.094,0,0,1-1.342.386,3.152,3.152,0,0,1-1.4-.3v-.975a5.771,5.771,0,0,0,.848.315,2.513,2.513,0,0,0,.635.091.9.9,0,0,0,.53-.132.451.451,0,0,0,.184-.393.435.435,0,0,0-.081-.259.909.909,0,0,0-.239-.218,6.127,6.127,0,0,0-.641-.335,3.044,3.044,0,0,1-.681-.409,1.54,1.54,0,0,1-.362-.457,1.3,1.3,0,0,1-.136-.609,1.279,1.279,0,0,1,.445-1.032,1.85,1.85,0,0,1,1.231-.376,2.907,2.907,0,0,1,.736.091,5.072,5.072,0,0,1,.733.257l-.338.816a4.976,4.976,0,0,0-.655-.227,2.1,2.1,0,0,0-.509-.064.674.674,0,0,0-.457.139.457.457,0,0,0-.159.362.449.449,0,0,0,.064.242.7.7,0,0,0,.2.2,6.333,6.333,0,0,0,.665.347,2.644,2.644,0,0,1,.951.665A1.3,1.3,0,0,1,659.205,341.785Z",
    transform: "translate(-646.846 -338.14)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2335",
    "data-name": "Caminho 2335",
    d: "M847.76,480.666v-.846h1.818v.846Z",
    transform: "translate(-834.92 -477.082)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2336",
    "data-name": "Caminho 2336",
    d: "M970.563,402.3a1.952,1.952,0,0,1-1.428-.5,1.909,1.909,0,0,1-.515-1.428,2.1,2.1,0,0,1,.476-1.471,1.693,1.693,0,0,1,1.315-.52,1.667,1.667,0,0,1,1.249.457,1.729,1.729,0,0,1,.447,1.262v.5h-2.44a.993.993,0,0,0,.261.687.917.917,0,0,0,.683.247,2.844,2.844,0,0,0,.646-.071,3.243,3.243,0,0,0,.636-.227v.8a2.422,2.422,0,0,1-.579.2A3.619,3.619,0,0,1,970.563,402.3Zm-.145-3.188a.655.655,0,0,0-.515.208.963.963,0,0,0-.213.591h1.449a.862.862,0,0,0-.2-.591A.676.676,0,0,0,970.417,399.115Z",
    transform: "translate(-953.444 -397.216)",
    fill: "#64c2c8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfsE);
export default __webpack_public_path__ + "static/media/nfsE.dfe18a5d992896b257112a7e28527019.svg";
export { ForwardRef as ReactComponent };